import { render } from "./GeneralSettings.vue?vue&type=template&id=fac84c2a&ts=true"
import script from "./GeneralSettings.vue?vue&type=script&lang=ts"
export * from "./GeneralSettings.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__